export default __webpack_public_path__ + "advantage-6318eb9.png";